import React, { Component } from "react";
import classnames from "classnames";
import styles from "../IndicatorsExplanation/IndicatorsExplanation.local.scss";
import { getIndicatorLabel } from "Utils";
import { Tooltip } from "antd";
import { ICONS, SvgIcon } from "../Common/Icons";
import _ from "i18n";

class ItemExplanation extends Component {
  renderDefaultActions = item => {
    return (
      <div
        className={styles.actions}
        onClick={event => {
          event.stopPropagation();
        }}
      >
        <div>
          <Tooltip placement="bottom" title={_("delete")}>
            <span
              className={styles.action}
              onClick={() => this.props.handleDeleteExplanation(item.id)}
            >
              <SvgIcon icon={ICONS.Garbage} className={styles.delete} />
            </span>
          </Tooltip>

          <Tooltip placement="bottom" title={_("update")}>
            <span
              className={styles.action}
              onClick={() => this.props.onClickUpdateExplanation(item.id)}
            >
              <SvgIcon icon={ICONS.EDIT_ICON} className={styles.update} />
            </span>
          </Tooltip>
        </div>
      </div>
    );
  };
  render() {
    const { item, lng, indicators } = this.props;
    return (
      <div
        className={classnames(
          styles.item_explanation,
          styles.standard,
          styles.active
        )}
      >
        <div className={styles.item_enabled_status}>
          <img
            src={"/img/icons/white_check_mark.svg"}
            alt={""}
            className={styles.status_check}
          />
        </div>
        <span className={styles.item_label}>
          {getIndicatorLabel(item.target, indicators)}
        </span>
        <div className={styles.explanation}>
          <span>
            {item.content[lng] && item.content[lng].substring(0, 80)}
            {item.content[lng] && item.content[lng].length > 80 ? "..." : ""}
          </span>
        </div>

        {this.renderDefaultActions(item)}
      </div>
    );
  }
}

export default ItemExplanation;



// WEBPACK FOOTER //
// ./src/components/IndicatorsExplanation/ItemExplanation.js